import { PropertyTypes } from "epsm-api-types";
import {
	DEFAULT_DATE_OPTIONS,
	formatValue,
} from "@/components/widgets/helpers/FormattingHelpers";
import type { SubscriptionPeriod } from "@/shared/components/PricingTable/types";

export function getNewNextPaymentDate(
	nextPaymentDate: number | null,
	newPeriod: SubscriptionPeriod,
	currentPeriod: SubscriptionPeriod,
): string {
	if (newPeriod === currentPeriod) {
		return formatValue(nextPaymentDate, PropertyTypes.DATE);
	}

	const today = new Date();
	const next = new Date(today);

	if (newPeriod === "month") {
		next.setMonth(next.getMonth() + 1);
	} else if (newPeriod === "year") {
		next.setFullYear(today.getFullYear() + 1);
	} else {
		return "N/A";
	}

	return formatValue(next, PropertyTypes.DATE, DEFAULT_DATE_OPTIONS, "N/A");
}

export type GetNewNextPaymentDateFn = typeof getNewNextPaymentDate;
